import React, { Fragment, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, TextField } from '@material-ui/core';
import { updateANTestService, setABTestParamAction, searchTbTests, endAbTest, getAbTestResultAction, getABTest, getSegment } from '../../../actions/homeAppActions';
import LoadingIndicator from '../../../common/LoadingIndicator';
import ABTestManualResult from './ABTestManualResult';
import ABTestManualSearch from './ABTestManualSearch';
import { isNormalInteger } from '../../../util/util';
import { request } from '../../../util/request';
import { API_BASE_URL } from '../../../constants';
import { getHeaders } from '../../../util/actionUtil';
import AddServiceFilter from './AddServiceFilter';
import ANServiceFilterNoTest from './ANServiceFilterNoTest';

function AddANTestService({ updateANTestService, getCountAction, history, abTestTabCategory, id, segMentId, abTestParam, fetching, setABTestParamAction, regionList, regionPlatformList, getAbTestResultAction, getSegment }) {
  const today = new Date();
  const yestreday = new Date();
  const nextMonthDate = new Date();
  yestreday.setDate(today.getDate() - 1);
  nextMonthDate.setMonth(today.getMonth() + 1);
  const monthAgoDate = new Date();
  monthAgoDate.setMonth(monthAgoDate.getMonth() - 1);
  const [cat, setCat] = React.useState(abTestTabCategory.find(n => n.categoryId == id) || {});
  const [result, setResult] = React.useState([]);
  const [addData, setAddData] = React.useState([]);
  const [deleteData, setDeleteData] = React.useState([]);
  const [time, setTime] = useState();
  const [title, setTitle] = useState('');
  const [description, setDescription] = React.useState('');
  const [startDate, setStartDate] = React.useState(today.toLocaleDateString('en-CA'));
  const [endDate, setEndDate] = React.useState(nextMonthDate.toLocaleDateString('en-CA'));
  const [startTimeAnt, setStartTimeAnt] = useState('');
  const [endTimeAnt, setEndTimeAnt] = React.useState('');
  const [tabCode, setTabCode] = React.useState('');
  const [categoryCode, setCategoryCode] = React.useState('');
  const [mappingType, setMappingType] = React.useState('');
  const [segmentId, setSegmentId] = React.useState('');
  const [countryCode, setCountryCode] = React.useState('');
  const selectedTableRef = useRef();
  const [deviceType, setDeviceType] = React.useState('');
  const [platformVersion, setPlatformVersion] = React.useState('');
  const [endDateCheck, setEndDateCheck] = React.useState();
  const [validToUpdate, setValidToUpdate] = React.useState(true);
  const [abtestId, setAbtestId] = React.useState('');
  const [segmentType, setSegmentType] = React.useState('');
  const [region, setRegion] = React.useState('');
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth() + 1 > 9 ? now.getUTCMonth() + 1 : '0' + (now.getUTCMonth() + 1);
  const day = now.getUTCDate() > 9 ? now.getUTCDate() : '0' + now.getUTCDate();
  const hours = now.getUTCHours() > 9 ? now.getUTCHours() : '0' + now.getUTCHours();
  const minutes = now.getUTCMinutes() > 9 ? now.getUTCMinutes() : '0' + now.getUTCMinutes();
  const seconds = now.getUTCSeconds() > 9 ? now.getUTCSeconds() : '0' + now.getUTCSeconds();
  const [abtestSubid, setAbtestSubid] = useState();

  React.useEffect(() => {
    setTime(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}`);
    if (id) {
      fetchTbTestData();
      getAbTestResultAction(id, segMentId);
    }
  }, [id]);
  const dayOfweekList = [
    'SUN',
    'MON',
    'TUE',
    'WED',
    'THU',
    'FRI',
    'SAT',
  ];
  const [dayOfWeek, setDayOfWeek] = React.useState(dayOfweekList);
  const fetchTbTestData = async () => {
    const tbTestData = await request(`/api/abtest/${id}/segment/${segMentId}`, 'GET', null, true);
    setDeviceType(tbTestData.deviceType);
    setCountryCode(tbTestData.countryCode);
    setPlatformVersion(tbTestData.platformVersion);
    setTabCode(tbTestData.tabCode);
    setCategoryCode(tbTestData.categoryCode);
    setMappingType(tbTestData.mappingType);
    setEndDateCheck(tbTestData.endTime);
    setAbtestId(tbTestData.abtestId);
    setSegmentType(tbTestData.segmentType);
    setSegmentId(tbTestData.segmentId);
    setAbtestSubid(tbTestData.abtestSubid);
    setDescription(tbTestData.description)
    var startTime = new Date(tbTestData.startTime);
    startTime.setDate(startTime.getDate() - 1);
    let utcHour = await getUTCHour();
    startTime.setHours(utcHour);
    var todayDateUTC = new Date(formatDate(new Date()));
    setValidToUpdate(checkForeligebleForEdit(tbTestData) || todayDateUTC > startTime);
    setABTestParamAction(tbTestData.deviceType, tbTestData.countryCode, tbTestData.region, tbTestData.platformVersion, '', '')
    getSegment(tbTestData.countryCode, tbTestData.platformVersion);
  };
  async function getUTCHour() {
    let utcHour = await fetch(API_BASE_URL + '/abtest/utchour', {
      method: 'GET',
      headers: getHeaders(),
    })
      .then(res => res.json())
      .then(body => {
        return body;
      });
    return utcHour;
  }

  function checkForeligebleForEdit(ab) {
    if (new Date(ab.forcedEndTime) <= new Date(formatDate(new Date()))) {
      return true;
    } else if (new Date(formatDate(new Date())) < new Date(ab.startTime)) {
      return false;
    } else {
      return true;
    }
  }

  const clickSave = async e => {
    e.preventDefault();
    const uniqueValues = new Set(result.map(v => parseInt(v.result_order)));
    debugger
    if (!title || title.trim().length === 0) alert('Please enter the Title');
    else if (title.length > 255) alert('Title should be within 255 characters');
    else if (!startDate) alert('Please select a start date');
    else if (startTimeAnt === '') alert('Please select start time');
    else if (!endDate) alert('Please select an end date');
    else if (endTimeAnt === '') alert('Please select end time');
    else if (!deviceType) alert('Please select a device type');
    else if (!countryCode) alert('Please select a Country Code');
    else if (!platformVersion) alert('Please select a platform version');
    else if (!tabCode) alert('Please select a tab code');
    else if (!categoryCode) alert('Please select a category code');
    else if (!segmentType) alert('Please select a Segment Type');
    else if (!segmentId) alert('Please select a Segment');
    else if (dayOfWeek && dayOfWeek.length === 0) alert('Please select at least one day');
    else if (result.find(n => n.result_order === '')) alert('Some order is empty ! Please enter the order !');
    else if (uniqueValues.size < result.length) {
      const duplicateCounts = result.reduce((acc, item) => {
        const order = item.result_order;
        acc[order] = (acc[order] || 0) + 1;
        return acc;
      }, {});
      const duplicates = Object.keys(duplicateCounts)
        .filter(order => duplicateCounts[order] > 1)
        .map(order => parseInt(order));
      alert(`Some order is duplicated ! Please remove duplicate order (${duplicates.join(', ')})`);
    }
    else if (window.confirm('Are you sure to save the result?')) {
      let startTimeLocal = startTimeAnt > 9 ? startDate + ' ' + startTimeAnt + ':00:00' : startDate + ' 0' + startTimeAnt + ':00:00';
      var startTimeNow = new Date(startTimeLocal);
      startTimeNow.setDate(startTimeNow.getDate() - 1);
      let utcHour = await getUTCHour();
      startTimeNow.setHours(utcHour);
      var todayDateUTC = new Date(formatDate(new Date()));
      let endTimeLocal = endTimeAnt > 9 ? endDate + ' ' + endTimeAnt + ':00:00' : endDate + ' 0' + endTimeAnt + ':00:00';
      let idx = id;
      const newResult = result.map(n => {
        const { country_code, cp_idx, provider_idx, type, content_id, result_order, genre } = n;
        let serviceResult = { categoryIdx: id, countryCode: country_code };
        serviceResult.providerIdx = cp_idx || provider_idx;
        serviceResult.contentType = type;
        serviceResult.contentId = content_id;
        serviceResult.resultOrder = result_order;
        serviceResult.genreCode = genre;
        return serviceResult;
      });
      const addSeviceData = {
        idx,
        title,
        startTimeLocal,
        endTimeLocal,
        tabCode,
        categoryCode,
        segmentId,
        mappingType,
        countryCode,
        deviceType,
        platformVersion,
        abtestId,
        segmentType,
        abtestSubid,
        serviceResult: newResult,
        dayOfWeek,
      };
      updateANTestService(addSeviceData);
    }
  };

  const selectSearch = rows => {
    if (rows.find(n => result.find(n2 => n2.content_id === n.id && n2.cp_idx == n.cp_idx))) {
      alert('content is already exist !');
    } else {
      let startOrder = Math.max(...result.map(n => n.result_order)) + 1;
      startOrder = startOrder === -Infinity ? 1 : startOrder;

      setAddData(
        rows.map((n, i) => {
          const { cp_idx, cp, id, name, image, type, series_id, genre } = n;
          return { cp_idx: cp_idx, cp_id: cp, name: name, image: image, country_code: countryCode, type: type, content_id: id, result_order: startOrder + i, series_id: series_id, genre: genre };
        }),
      );
    }
  };

  const selectResult = rows => {
    setDeleteData(
      rows.map(n => {
        const { cp_idx, content_id, name, type, genre } = n;
        return { cp_idx: cp_idx, content_id: content_id, name: name, type: type, genre: genre };
      }),
    );
  };

  const addResult = () => {
    if (addData.find(n => result.find(n2 => n2.content_id === n.content_id && n2.cp_idx === n.cp_idx))) {
      alert('content is already exist !');
    } else if (checkTvShowSearies(addData) || checkDuplicateSeriesList(addData)) {
      alert('Only one season allowed per series!');
      selectedTableRef.current.onAllSelected(false);
    } else {
      selectedTableRef.current.onAllSelected(false);
      setResult(result.concat(addData));
      setAddData([]);
    }
  };

  const removeResult = () => {
    setResult(result.filter(n => !deleteData.find(n2 => n2.cp_idx === n.cp_idx && n2.content_id === n.content_id)));
    setDeleteData([]);
  };

  const renderOrder = n => (
    <TextField
      fullWidth
      margin="dense"
      value={n.result_order}
      onChange={e => {
        if (e.target.value === '0') alert('The order must be greater than 0 ! Please re-enter !');
        else if (!isNormalInteger(e.target.value) && e.target.value !== '') alert('The order is not natural number ! Please enter natural number !');
        else {
          const newResult = result.slice();
          newResult.find(n2 => n2.cp_idx === n.cp_idx && n2.content_id === n.content_id).result_order = e.target.value;
          setResult(newResult);
        }
      }}
    />
  );

  const checkTvShowSearies = rows => {
    return rows.find(
      n =>
        result.filter(r => {
          if (r.category_idx) {
            return r.provider_idx === n.cp_idx && r.series_id === n.series_id && n.type === 'tvshow-series';
          } else {
            return r.cp_idx === n.cp_idx && r.series_id === n.series_id && n.type === 'tvshow-series';
          }
        })[0],
    );
  };

  const checkDuplicateSeriesList = data => {
    const tvShowData = data.filter(n => n.type === 'tvshow-series');
    const lookup = tvShowData.reduce((a, e) => {
      a[e.series_id] = ++a[e.series_id] || 0;
      return a;
    }, {});

    return tvShowData.filter(e => lookup[e.series_id]).length >= 2;
  };

  const getCountryCode = value => {
    gePtlatformVersion(value);
    return regionList.find(n => n.deviceType === value).list[0].cntry;
  };

  const gePtlatformVersion = (deviceType, region) => {
    if (regionPlatformList.find(n => n.deviceType === deviceType && n.region === region)) {
      return regionPlatformList.find(n => n.deviceType === deviceType && n.region === region).platformVersion;
    }
    return '';
  };

  const getRegion = (deviceType, countryCode) => {
    abTestParam.region = '';
    (regionList.find(n => n.deviceType === deviceType) || { list: [] }).list.forEach(a => {
      if (a.cntry.includes(countryCode)) {
        abTestParam.region = a.region;
      }
    });
    return abTestParam.region;
  };

  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  function formatDate(date) {
    return [date.getFullYear(), padTo2Digits(date.getUTCMonth() + 1), padTo2Digits(date.getUTCDate())].join('-') + ' ' + [padTo2Digits(date.getUTCHours()), padTo2Digits(date.getUTCMinutes()), padTo2Digits(date.getUTCSeconds())].join(':');
  }

  return (
    <Fragment>
      <form id="addRowFrm" autoComplete="off">
        <h5>Current Time (UTC): {time}</h5>
        {id ?
          <AddServiceFilter
            isItEdit={false}
            title={title}
            handleChangeTitle={e => {
              setTitle('');
              setTitle(e.target.value);
            }}
            startDate={startDate}
            handleChangeStartDate={e => {
              setStartDate(e.target.value);
              setEndDate('');
              setEndTimeAnt('')
            }}
            startTimeAnt={startTimeAnt}
            handleChangeStartTime={e => {
              setStartTimeAnt(e.target.value);
              setEndTimeAnt('')
            }}
            endDate={endDate}
            handleChangeEndDate={e => {
              setEndDate(e.target.value);
              setEndTimeAnt('')
            }}
            endTimeAnt={endTimeAnt}
            handleChangeEndTime={e => {
              setEndTimeAnt(e.target.value);
            }}
            regionList={regionList}
            deviceType={abTestParam.deviceType}
            handleChangeDeviceType={e => {
              setABTestParamAction(e.target.value, countryCode, regionList.find(n => n.deviceType === e.target.value).list[0].region, gePtlatformVersion(e.target.value, regionList.find(n => n.deviceType === e.target.value).list[0].region), abTestParam.mappingType);
              setTabCode('');
              setCategoryCode('');
            }}
            countryCode={abTestParam.countryCode}
            region={getRegion(deviceType, countryCode)}
            handleChangeCountry={e => {
              setABTestParamAction(abTestParam.deviceType, e.target.value, getRegion(deviceType, e.target.value), gePtlatformVersion(abTestParam.deviceType, e.target.value), abTestParam.mappingType);
              setTabCode('');
              setCategoryCode('');
            }}
            regionPlatformList={regionPlatformList}
            platformVersion={abTestParam.platformVersion}
            abTestTabCategory={abTestTabCategory}
            handleChangePlatformVersion={e => {
              setABTestParamAction(abTestParam.deviceType, abTestParam.countryCode, abTestParam.region, e.target.value, abTestParam.mappingType);
              setTabCode('');
              setCategoryCode('');
            }}
            tabCode={tabCode}
            handleChangeTab={e => {
              setABTestParamAction(abTestParam.deviceType, abTestParam.countryCode, abTestParam.region, abTestParam.platformVersion, abTestParam.mappingType);
              setTabCode(e.target.value);
              setCategoryCode('');
            }}
            categoryCode={categoryCode}
            handleChangeCategory={e => {
              setABTestParamAction(abTestParam.deviceType, abTestParam.countryCode, abTestParam.region, abTestParam.platformVersion, abTestParam.mappingType);
              setCategoryCode(e.target.value);
            }}
            segmentType={segmentType}
            handleChangeSegmentType={e => {
              setSegmentType(e.target.value);
            }}
            segmentId={segmentId}
            handleChangeSegment={e => {
              setSegmentId(e.target.value);
            }}
            mappingType={abTestParam.mappingType}
            handleChangeMappingType={e => {
              setABTestParamAction(abTestParam.deviceType, abTestParam.countryCode, abTestParam.region, abTestParam.platformVersion, e.target.value);
            }}
            dayOfWeek={dayOfWeek}
            handleDayOfWeekChange={ev => {
              const {
                target: { value },
              } = ev;
              setDayOfWeek(
                typeof value === 'string' ? value.split(',') : value,
              );
            }}
            description={description}
          /> :
          <ANServiceFilterNoTest
            title={title}
            handleChangeTitle={e => {
              setTitle(e.target.value);
            }}
            regionList={regionList}
            deviceType={deviceType}
            handleChangeDeviceType={e => {
              setDeviceType(e.target.value)
            }}
            countryCode={countryCode}
            region={getRegion(deviceType, countryCode)}
            handleChangeCountry={value => {
              setCountryCode(value)
              setABTestParamAction(abTestParam.deviceType, value, getRegion(deviceType, value), gePtlatformVersion(abTestParam.deviceType, value), abTestParam.mappingType);
            }}
            regionPlatformList={regionPlatformList}
            platformVersion={platformVersion}
            abTestTabCategory={abTestTabCategory}
            handleChangePlatformVersion={e => {
              setPlatformVersion(e.target.value)
            }}
            tabCode={tabCode}
            handleChangeTab={value => {
              setTabCode(value);
            }}
            categoryCode={categoryCode}
            handleChangeCategory={value => {
              setCategoryCode(value);
            }}
            startDate={startDate}
            handleChangeStartDate={e => {
              setStartDate(e.target.value);
              setEndDate('');
              setEndTimeAnt('')
            }}
            startTimeAnt={startTimeAnt}
            handleChangeStartTime={e => {
              setStartTimeAnt(e.target.value);
              setEndTimeAnt('')
            }}
            endDate={endDate}
            handleChangeEndDate={e => {
              setEndDate(e.target.value);
              setEndTimeAnt('')
            }}
            endTimeAnt={endTimeAnt}
            handleChangeEndTime={e => {
              setEndTimeAnt(e.target.value);
            }}
            segmentType={segmentType}
            handleChangeSegmentType={e => {
              setSegmentType(e.target.value);
            }}
            segmentId={segmentId}
            handleChangeSegment={e => {
              setSegmentId(e.target.value);
            }}
            dayOfWeek={dayOfWeek}
            handleDayOfWeekChange={ev => {
              const {
                target: { value },
              } = ev;
              setDayOfWeek(
                typeof value === 'string' ? value.split(',') : value,
              );
            }}
            description={description}
          />
        }
        <div className="channel_mapping_wrap">
          <ABTestManualSearch
            getCountAction={getCountAction}
            tabCode={tabCode}
            abTestTabCategory={abTestTabCategory}
            categoryCode={categoryCode}
            countryCode={countryCode}
            tableRef={selectedTableRef}
            cat={cat}
            selectSearch={selectSearch}
            status={abTestParam.status}
            categoryResultData={result}
            region={abTestParam.region}
          />
          {fetching ? (
            <div className="loading_wrap">
              <LoadingIndicator />
            </div>
          ) : (
            <ABTestManualResult id={id} countryCode={countryCode} cat={cat} result={result} setResult={setResult} renderOrder={renderOrder} selectResult={selectResult} onClickAdd={addResult} onClickDelete={removeResult} isItEdit={false} />
          )}
        </div>
        <div className="btn_set_wrap">
          <Button className="btn_color2" onClick={clickSave}>
            Save
          </Button>
          <Button
            className="btn_color2"
            onClick={() => {
              history.push('/RECOMMEND/anservice');
            }}>
            Back
          </Button>
        </div>
      </form>
    </Fragment>
  );
}

AddANTestService.propTypes = {
  notifications: PropTypes.array.isRequired,
  abTestTabCategory: PropTypes.array.isRequired,
  segment: PropTypes.array.isRequired,
  abTestParam: PropTypes.object.isRequired,
  getNotifications: PropTypes.func.isRequired,
  addNotification: PropTypes.func.isRequired,
  updateNotification: PropTypes.func.isRequired,
  publishNotification: PropTypes.func.isRequired,
  getSupportLanguages: PropTypes.func.isRequired,
  searchNotification: PropTypes.func.isRequired,
  regionList: PropTypes.array.isRequired,
  regionPlatformList: PropTypes.array.isRequired,
  getABTest: PropTypes.func.isRequired,
  endAbTest: PropTypes.func.isRequired,
  searchTbTests: PropTypes.array.isRequired,
  updateRecommendationService: PropTypes.func.isRequired,
  getAbTestResultAction: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  notifications: state.homeApp.notifications,
  abTestParam: state.homeApp.abTestParam,
  abTestTabCategory: state.homeApp.abTestTabCategory,
  segment: state.homeApp.segment,
  regionList: state.homeApp.regionList,
  regionPlatformList: state.homeApp.regionPlatformList,
  fetching: state.homeApp.manualResultFetching,
});

const mapDispatchToProps = dispatch => ({
  setABTestParamAction(deviceType, countryCode, region, platformVersion, mappingType, status) {
    dispatch(setABTestParamAction(deviceType, countryCode, region, platformVersion, mappingType, status));
  },
  getSegment(region, platformVersion) {
    dispatch(getSegment(region, platformVersion));
  },
  getAbTestResultAction(id, segMentId) {
    dispatch(getAbTestResultAction(id, segMentId));
  },
  getABTest(id) {
    dispatch(getABTest(id));
  },
  endAbTest: id => dispatch(endAbTest(id)),
  searchTbTests: (abTestTitle, startDate, endDate, tabCode, categoryCode, deviceType, region, platformVersion, status) => dispatch(searchTbTests(abTestTitle, startDate, endDate, tabCode, categoryCode, deviceType, region, platformVersion, status)),
  updateANTestService(addSeviceData) {
    dispatch(updateANTestService(addSeviceData));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddANTestService));
